export * from './VehiclesModule'
export const vehiclesPath = '/et/company/:companyId/vehicleModule'
